<script lang="ts">
import { defineComponent, watch } from "vue";
import ValidierungsFehler from "@/components/ValidierungsFehler.vue";
import Zeile from "@/components/grid/Zeile.vue";
import Zelle from "@/components/grid/Zelle.vue";
import TitelZelle from "@/components/grid/TitelZelle.vue";
import gebaeudeUtils from "@/businesslogic/utils/gebaeudeUtils";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "GebaeudeTyp",
  components: {
    TitelZelle,
    Zelle,
    Zeile,
    ValidierungsFehler,
  },
  props: {
    fehler: {
      type: Object,
    },
  },
  setup() {
    const piniaStore = useFormStore();
    const { berechneGebaeudetyp } = gebaeudeUtils();

    watch(
      () => piniaStore.state.gebaeudedaten.gebaeudesubtyp,
      () => {
        if (piniaStore.state.gebaeudedaten.gebaeudesubtyp !== "mfh") {
          piniaStore.state.gebaeudedaten.anzahlWohnungen = 1;
        }
        if (
          piniaStore.state.gebaeudedaten.gebaeudesubtyp === "mfh" &&
          piniaStore.state.ferienhaus.versicherungsumfang === "0003"
        ) {
          piniaStore.state.ferienhaus.versicherungsumfang = "0002";
        }
        piniaStore.state.gebaeudedaten.gebaeudetyp = berechneGebaeudetyp(
          piniaStore.state.gebaeudedaten.gebaeudesubtyp,
          piniaStore.state.gebaeudedaten.anzahlWohnungen,
        );
      },
    );

    return {
      piniaStore,
    };
  },
});
</script>

<template>
  <zeile>
    <titel-zelle><strong>Gebäudetyp</strong></titel-zelle>
    <zelle class="iconRadioGebaeudetyp">
      <input
        id="einfamilienhaus"
        name="gebaeudesubtyp"
        v-model="piniaStore.state.gebaeudedaten.gebaeudesubtyp"
        type="radio"
        value="efh"
        required
        data-fehlermeldung="Bitte treffen Sie eine Auswahl."
        data-cy="gebaeudetypEinfamilie"
        tabindex="0"
        autofocus
        class="no-outline"
        aria-required="true"
        aria-label="Einfamilienhaus"
      />
      <label for="einfamilienhaus" class="radiolabelGebaeudetyp"></label>
      <input
        id="doppelhaushaelfte"
        name="gebaeudesubtyp"
        v-model="piniaStore.state.gebaeudedaten.gebaeudesubtyp"
        type="radio"
        value="dhh"
        data-cy="doppelhaushaelfte"
        class="no-outline"
        aria-label="Doppelhaushälfte"
      />
      <label for="doppelhaushaelfte" class="radiolabelGebaeudetyp"></label>
      <input
        id="reihenhaus"
        name="gebaeudesubtyp"
        v-model="piniaStore.state.gebaeudedaten.gebaeudesubtyp"
        type="radio"
        value="rh"
        data-cy="reihenhaus"
        class="no-outline"
        aria-label="Reihenhaus"
      />
      <label for="reihenhaus" class="radiolabelGebaeudetyp"></label>
      <input
        id="mehrfamilienhaus"
        name="gebaeudesubtyp"
        v-model="piniaStore.state.gebaeudedaten.gebaeudesubtyp"
        type="radio"
        value="mfh"
        data-cy="mehrfamilienhaus"
        class="no-outline"
        aria-label="Mehrfamilienhaus"
      />
      <label for="mehrfamilienhaus" class="radiolabelGebaeudetyp"></label>
      <validierungs-fehler :fehler-text="fehler.gebaeudesubtyp" :reduzierter-abstand="true" />
    </zelle>
  </zeile>
</template>

<style scoped></style>
